/* Kombin seritleri icin yatay kaydirma oklari.
   Tema oklariyla ayni gorunum (carousel__navigation-button), davranis burada:
   Swiper yok, dogrudan scrollLeft.

   ANIMASYON NOTU (olculdu, 27 Agu V16 onizleme): sayfa gorunur degilken
   (document.hidden) tarayici requestAnimationFrame'i hic calistirmiyor - ve ayni
   sebeple scrollBy({behavior:'smooth'}) de sessizce hicbir sey yapmiyor. Bu yuzden
   animasyon elle yapiliyor ve HER durumda bir cikis yolu var:
     - hareketi azalt tercihi, gizli sekme veya rAF yoksa  -> aninda atla
     - animasyon beklenen surede bitmezse                  -> hedefe atla
   Boylece ok her kosulda kaydirir; animasyon yalnizca bir suslemedir.

   Serit SONRADAN dolabilir (kombin sayfasindaki oneri seridi kartlari ajax ile
   gelir); MutationObserver ile icerik degisince oklar yeniden degerlendirilir.

   Ok yalnizca tasma varsa gorunur; uclarda ilgili buton disabled olur. */
(function () {
  var SURE = 380;

  function kur(sarmal) {
    var serit = sarmal.querySelector('[data-kl-serit]');
    var oklar = sarmal.querySelector('[data-kl-oklar]');
    if (!serit || !oklar) return;
    var geri = oklar.querySelector('[data-kl-prev]');
    var ileri = oklar.querySelector('[data-kl-next]');
    if (!geri || !ileri) return;
    var suruyor = false;

    function adim() {
      var kart = serit.firstElementChild;
      if (!kart) return serit.clientWidth;
      var stil = window.getComputedStyle(serit);
      var bosluk = parseFloat(stil.columnGap || stil.gap || '0') || 0;
      var birim = kart.getBoundingClientRect().width + bosluk;
      if (!(birim > 0)) return serit.clientWidth;
      /* Gorunen kart sayisi kadar kaydir, en az bir kart */
      var adet = Math.max(1, Math.floor(serit.clientWidth / birim));
      return birim * adet;
    }

    function tazele() {
      var tasma = serit.scrollWidth - serit.clientWidth;
      if (tasma < 4) {
        oklar.setAttribute('hidden', '');
        return;
      }
      oklar.removeAttribute('hidden');
      var x = serit.scrollLeft;
      geri.disabled = x < 4;
      ileri.disabled = x > tasma - 4;
    }

    function bitir(hedef) {
      serit.scrollLeft = hedef;
      suruyor = false;
      tazele();
    }

    function kaydir(yon) {
      if (suruyor) return;
      var tasma = serit.scrollWidth - serit.clientWidth;
      var bas = serit.scrollLeft;
      var hedef = Math.max(0, Math.min(tasma, bas + yon * adim()));
      var mesafe = hedef - bas;
      if (Math.abs(mesafe) < 1) { tazele(); return; }

      var azalt = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (azalt || document.hidden || !window.requestAnimationFrame) {
        bitir(hedef);
        return;
      }

      suruyor = true;
      var t0 = null;
      /* Animasyon hic baslamazsa ya da yarida kalirsa kaydirma yine de olsun */
      var koruma = setTimeout(function () {
        if (suruyor) bitir(hedef);
      }, SURE + 300);

      function kare(zaman) {
        if (!suruyor) return;
        if (t0 === null) t0 = zaman;
        var o = Math.min(1, (zaman - t0) / SURE);
        /* easeInOutQuad */
        var e = o < 0.5 ? 2 * o * o : 1 - Math.pow(-2 * o + 2, 2) / 2;
        serit.scrollLeft = bas + mesafe * e;
        if (o < 1) {
          requestAnimationFrame(kare);
        } else {
          clearTimeout(koruma);
          bitir(hedef);
        }
      }
      requestAnimationFrame(kare);
    }

    geri.addEventListener('click', function () { kaydir(-1); });
    ileri.addEventListener('click', function () { kaydir(1); });
    serit.addEventListener('scroll', function () { if (!suruyor) tazele(); }, { passive: true });
    window.addEventListener('resize', tazele);
    if (window.ResizeObserver) {
      try { new ResizeObserver(tazele).observe(serit); } catch (e) {}
    }
    /* Kartlar sonradan gelirse (ajax oneri seridi) oklari yeniden degerlendir */
    if (window.MutationObserver) {
      try {
        new MutationObserver(function () { tazele(); })
          .observe(serit, { childList: true });
      } catch (e) {}
    }
    tazele();
  }

  function hepsi() {
    var sarmallar = document.querySelectorAll('[data-kl-sarmal]');
    for (var i = 0; i < sarmallar.length; i++) {
      if (sarmallar[i].hasAttribute('data-kl-kuruldu')) continue;
      sarmallar[i].setAttribute('data-kl-kuruldu', '');
      kur(sarmallar[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hepsi);
  } else {
    hepsi();
  }
  /* Tema editorunde bolum yeniden yuklendiginde */
  document.addEventListener('shopify:section:load', hepsi);
})();
